import React, { useState, useEffect } from 'react';
import Banner from '../Header/Banner';
import HomeImages from './HomeImages';
import { useAdSource } from 'dsoa-components';
import HomeCourse from './HomeCourse';
import { coursesByAbbreviations } from 'dsoapi';
import { COURSE_ABBRS } from './courseAbbreviations';

const Home = ({ setTitle = () => {} }) => {
  useAdSource();
  const [courseData, setCourseData] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCourseData = async () => {
      try {
        setLoading(true);
        const response = await coursesByAbbreviations({
          abbreviations: COURSE_ABBRS,
        });

        // Create a map of abbreviation to course data
        const courseMap = {};
        response.data.forEach((course) => {
          courseMap[course.abbreviation] = course;
        });

        setCourseData(courseMap);
      } catch (error) {
        console.error('Error fetching course data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchCourseData();
  }, []);

  setTitle('Home');

  // Helper function to get price display
  const getPrice = (abbreviation) => {
    if (loading || !courseData[abbreviation]) return '';
    return `$${parseFloat(courseData[abbreviation].price).toFixed(2)}`;
  };

  return (
    <>
      <Banner
        primary="Florida Educational Driving School"
        secondary="State and county certified driving courses"
      />
      <div className="ui main container">
        <HomeImages />
        <div style={{ height: '20px' }}></div>

        {/* BDI/TCAC Online Course */}
        <HomeCourse
          abbreviation="BDI"
          title={`4 Hour BDI/TCAC Online (Basic Driver Improvement) - ${getPrice(
            'BDI'
          )}`}
          features={[
            'Final price, No hidden fees, Includes all State Assessment & Processing Fees',
            'DHSMV State Approved',
            'Satisfies court ordered basic driving improvement course',
            'Prevent your insurance rates from being increased',
            'Once the course is completed, adjudication will be withheld',
            'All completions are instantly reported to the DMV and electronically filed with the Clerk of the Court',
            'Free completion certificate sent to your E-mail',
          ]}
          boldFeatures={[5, 6]}
        />

        {/* 12 Hour ADI Course */}
        <HomeCourse
          abbreviation="ADI12"
          title={`12 Hour ADI (Advanced Driver Improvement) Course - ${getPrice(
            'ADI12'
          )}`}
          description="<i>This course is for individuals who had their license suspended and need to enroll in a course to reinstate their driver's license or for individuals listed as a habitual traffic offender (HTO) by the State of Florida. This course can also be court ordered by a judge. This course can't be used as a substitute for a DUI school.</i>"
          features={[
            '100% Online Course',
            'Final price, No hidden fees, Includes all State Assessment & Processing Fees',
            'DHSMV State approved',
            'Required if your license has been Suspended or Revoked due to excessive Points',
            'Required if you are a Habitual Traffic Offender (HTO) Revocation',
            'Required if court ordered by a Judge',
            'Receive your Florida Hardship License and get your driving privileges reinstated',
            'Florida DMV Requirement to Complete a "3 Collisions in 3 Years" course',
            'DMV Required (Out of State Ticket) - If you received a traffic citation out of state and received a notice from Tallahassee requiring you to attend ADI',
            'Free enrollment letter is provided via e-mail immediately after registration allowing you to apply for your hardship license',
            'All completions are instantly reported to the DMV electronically',
            'Free completion certificate sent to your E-mail',
          ]}
          boldFeatures={[9, 10, 11]}
        />

        {/* TLSAE Course */}
        <HomeCourse
          abbreviation="TLSAE"
          title={`TLSAE (Drug & Alcohol / First Time Driver / Florida License Course / DATE Course / DATA Course) - ${getPrice(
            'TLSAE'
          )}`}
          features={[
            '$17.95 promotion price for August',
            'Final price, No hidden fees! (Includes all State Assessment & Processing Fees)',
            'Florida DHSMV State Approved, Best price online',
            'Required for Florida License if you are 18 or older',
            'Guaranteed to pass final exam',
            'Stop and resume where you left off',
            'All completions are instantly reported to the DMV electronically',
            'Free completion certificate sent to your E-mail',
            'Free Florida License Prep Test (a practice test for the DMV Road & Sign exam)',
            'Free DMV License Test Study Guide *Proved 99% Passing Grade',
            '*As of August 1, 2025, due to a new Florida law, if you are 18 or older you will continue to need this program as part of your licensing requirements. Anyone under 18 must complete the new 6-hour DETS course.',
          ]}
          boldFeatures={[7, 8, 9, 10, 11]}
        />

        {/* FLDETS*/}
        <HomeCourse
          abbreviation="FLDETS"
          title={`DETS - Driver Education Traffic Safety Course - ${getPrice(
            'FLDETS'
          )}`}
          features={[
            '$14.95 promotion price for August',
            'Final price, No hidden fees! (Includes all State Assessment & Processing Fees)',
            "Required for Florida Learner's Permit if you are 17 or younger",
            'Unlimited Course Retakes',
            'Stop and resume where you left off',
            'Take the course on any Computer, Mobile, or Tablet',
            'Florida DHSMV State Approved',
            'All completions are instantly reported to the DMV electronically',
            'Free Florida Permit Prep Test (a practice test for the DMV Road & Sign exam)',
            'Free DMV Permit Test Study Guide *Proved 99% Passing Grade',
            'Free completion certificate sent to your E-mail',
            '*As of August 1, 2025, due to a new Florida law, anyone under 18 must complete this new 6-hour DETS course.',
          ]}
          boldFeatures={[8, 9, 10, 11]}
        />

        {/* Florida Permit Test */}
        {/* <HomeCourse
          abbreviation="FLPERMIT"
          title={`Florida Permit Test (Road & Sign Test) - ${getPrice(
            'FLPERMIT'
          )}`}
          features={[
            'State Authorized',
            "Required for Florida learner's permit",
            'All completions are instantly reported electronically',
            'Final price, No hidden fees, Includes all State Assessment & Processing Fees',
          ]}
          boldFeatures={[2]}
        /> */}

        {/* Mature Driver Course */}
        <HomeCourse
          abbreviation="SDDAFL"
          title={`Mature Driver - Insurance Discount Course (Senior Driving Discount) - ${getPrice(
            'SDDAFL'
          )}`}
          features={[
            'Final price, No hidden fees, Includes all State Assessment & Processing Fees',
            'DHSMV State Approved',
            'Take in the comfort of your own home at your pace',
            'This online course is designed specifically for drivers 50 and older',
            "This online course can be completed quickly in only a few hours and includes several breaks. It's easy and simple",
            'This online course qualifies you for a mandatory reduction on your auto insurance rates for 3 years*',
            'Free completion certificate sent to your E-mail',
          ]}
          boldFeatures={[6]}
        />

        {/* 4 Hour TOAD Online Course */}
        <HomeCourse
          abbreviation="TOAD"
          title={`4 Hour TOAD Online (Youthful Offender / STOP Under 25 Defensive Driving Course / Safe New Attitude Program) - ${getPrice(
            'TOAD'
          )}`}
          features={[
            'We are the original creators of the T.O.A.D and Youthful Offender course',
            'Satisfies 4 hour court order for Youthful Offender, T.O.A.D, Teen, S.N.A.P. and Under 25 defensive driving course',
            'For 15-25 years old, who received traffic citations to attend a specialized driving program',
            'Once the course is completed, adjudication will be withheld',
            'Submissions are processed the same day the course is completed',
            'There are no tests',
            'Final price, No hidden fees, Includes all State Assessment & Processing Fees',
            'All completions are automatically reported to and electronically filed with the Clerk of the Court',
            'Free completion certificate sent to your E-mail',
          ]}
          boldFeatures={[8]}
        />

        {/* 8 Hour Basic Driver Improvement Course */}
        <HomeCourse
          abbreviation="BDI8"
          title={`8 Hour Basic Driver Improvement / Intermediate Driver Improvement Course - ${getPrice(
            'BDI8'
          )}`}
          description={`<i>If you've been referred by your court or have been ordered by a Florida Judge to complete an 8-Hour Driver Improvement class, this is the course for you. (Point Removal)</i>
          <br /> <br />Normally ordered by the courts as part of a sentencing judgment, this course is for the individual who has:`}
          features={[
            'Final price, No hidden fees, Includes all State Assessment & Processing Fees',
            'Received multiple traffic citations',
            'Received mandatory or serious traffic violations',
            'Been involved in numerous collisions',
            'Received a second ticket in the last 12 months',
            'Judge has ordered you to take an 8-Hour course',
            'All completions are automatically reported to and electronically filed with the Clerk of the Court',
            'Free completion certificate sent to your E-mail',
          ]}
          boldFeatures={[7]}
        />

        {/* 8 Hour Aggressive Driver Improvement Course */}
        <HomeCourse
          abbreviation="ADI"
          title={`8 Hour Aggressive Driver Improvement - ${getPrice('ADI')}`}
          description={`<i>This 8 Hour Aggressive Driver course is a Court Ordered Program, referred to you by your Court, or have been ordered by a Florida Judge to complete an 8-Hour Driver Improvement class. (Point Removal)</i>
            <br /><br />Students are required to take this course when ordered by the courts as part of a sentencing judgment, this course is for the individual who has:`}
          features={[
            'Final price, No hidden fees, Includes all State Assessment & Processing Fees',
            'Received Citations for Street or Drag Racing',
            'Court Ordered as part of a sentencing judgment',
            'Multiple speeding violations in a short period of time',
            'Multiple traffic offenses where the driver shows signs of aggressive driving',
            'Pre-trial requirement, probation officer and/or judge enter into a pre-trial diversion agreement',
            'All completions are automatically reported to and electronically filed with the Clerk of the Court',
            'Free completion certificate sent to your E-mail',
          ]}
          boldFeatures={[7]}
        />

        {/* 8 Hour TOAD Course */}
        <HomeCourse
          abbreviation="TOAD8"
          title={`8 Hour TOAD (Youthful Offender Driving Program / Teen Defensive Driving School / Safe New Attitude Program "SNAP") - ${getPrice(
            'TOAD8'
          )}`}
          features={[
            'We are the original creators of the T.O.A.D and Youthful Offender course',
            'Satisfies 8 hour court order for Youthful Offender, Teen, T.O.A.D, and "SNAP" driving school',
            'For 15-25 years old, who receive traffic citations to attend a specialized driving program',
            'Once the course is completed, adjudication will be withheld',
            'Submissions are processed the same day the course is completed',
            'Final price, No hidden fees, Includes all State Assessment & Processing Fees',
            'All completions are automatically reported to and electronically filed with the Clerk of the Court',
            'Free completion certificate sent to your E-mail',
          ]}
          boldFeatures={[7]}
        />

        {/* WCD Course */}
        <HomeCourse
          abbreviation="WCD"
          title={`(WCD) Wireless Communications Device Safety Course - ${getPrice(
            'WCD'
          )}`}
          features={[
            'Final price, No hidden fees, Includes all State Assessment & Processing Fees',
            'DHSMV State Approved',
            'Only 90 minutes to get your certificate of completion!',
            'Satisfies Election for Wireless Communications Device Course',
            'Satisfies Court Order for Wireless Communications Device Course',
            'Have the fine, and associated costs waived by the Clerk of Court',
            'Assessment of points MUST be waived by completing this course',
            'All completions are instantly reported to the DMV and electronically filed with the Clerk of the Court',
            'Free completion certificate sent to your E-mail',
          ]}
          boldFeatures={[7, 8]}
        />

        {/* STOP Course */}
        <HomeCourse
          abbreviation="STOP"
          title={`Senior Traffic Offender Plus - ${getPrice('STOP')}`}
          features={[
            "The program is court-ordered Only by a judge in lieu of a regular BDI. Unless court ordered by a judge, it can't be substituted for a BDI course.",
            'This is a court-ordered program for seniors 50 years and older who received a traffic citation',
            'Once the course is completed, adjudication will be withheld',
            'Take in the comfort of your own home at your pace',
            'Please make sure that the Program is ordered on your court disposition',
            'We are the original creators of the Senior Traffic Offender Plus.',
            'There are no tests',
            'Final price, No hidden fees, Includes all State Assessment & Processing Fees',
            'All completions are automatically reported to and electronically filed with the Clerk of the Court',
            'Free completion certificate sent to your E-mail',
          ]}
          boldFeatures={[9]}
        />

        {/* Bicycle Safety Course */}
        <HomeCourse
          abbreviation="FLBSC"
          title={`Bicycle Safety Course - ${getPrice('FLBSC')}`}
          features={[
            'Satisfies court order for the Bicycle Safety Course',
            'For anyone who received a court order to attend this specialized program',
            'Submissions are processed the same day the course is completed',
            'There are no tests',
            'Final price, No hidden fees, Includes all State Assessment & Processing Fees',
            'All completions are automatically reported to and electronically filed with the Clerk of the Court',
            'Free completion certificate sent to your E-mail',
          ]}
          boldFeatures={[6]}
        />
        {/* FLRST */}
        {/* <HomeCourse
          abbreviation="FLRST"
          title={`Florida Road Sign Test - ${getPrice('FLRST')}`}
          features={[
            'Submissions are processed the same day the course is completed',
            'There are no tests',
            'Final price, No hidden fees, Includes all State Assessment & Processing Fees',
            'All completions are automatically reported to and electronically filed with the Clerk of the Court',
            'Free completion certificate sent to your E-mail',
          ]}
          boldFeatures={[6]}
        /> */}
      </div>
      {/* Footer */}
      <footer
        style={{
          textAlign: 'center',
          padding: '20px',
        }}
      >
        © Copyright {new Date().getFullYear()} Florida Educational Driving
        School
        <br />
        <img
          src="https://static-content.fedsafe.com/images/FEDS-Sign-Logo.png"
          alt="Florida Educational Driving School Logo"
          style={{ width: '50px', height: 'auto', marginTop: '10px' }}
        />
      </footer>
    </>
  );
};

export default Home;
